import SmsChatView from '../../../components/SmsChatView';

interface Props {
  recordId: string;
  noteableName?: string;
}

const CandidateSmsNotes = ({ recordId, noteableName }: Props) => (
  <SmsChatView recordId={recordId} noteableType="Candidate" noteableName={noteableName} />
);

export default CandidateSmsNotes;
